module.exports = __webpack_public_path__ + "img/logout.f5e5ac98.svg";